// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__20Fmi","title":"Header_title__KGtL4","left":"Header_left__1g6BM","clinicName":"Header_clinicName__3kQ4g"};